import _ from 'lodash'

var billingFormSelector = 'form[name="paymentForm"]'

class SignupController {
  constructor(
      $log,
      AuthService,
      BillingService,
      SignupService,
      AddOns,
      $uibModal,
      http,
      config,
      $analytics
  ) {
    this.$log = $log
    this.authService = AuthService
    this.billingService = BillingService
    this.signupService = SignupService
    this.AddOns = AddOns
    this.$uibModal = $uibModal
    this.http = http
    this.termsUrl = config.accountEndpoint + '/terms'
    this.$analytics = $analytics

    this.user = {}
    this.product = null
    this.coverage = {}
    this.billingInfo = {}
    this._signupStep = 1

    this._clearMessages()
    this.submitting = false
  }

  get maxStepAvailable() {
    if ( this._registrationId ) {
      return Math.max(3, this.step)
    } else if ( !_.isEmpty(this.user.email) ) {
      return Math.max(2, this.step)
    } else {
      return this.step
    }
  }

  get step() {
    return this._signupStep
  }

  set step(value) {
    this._signupStep = value
  }

  trackCurrentStep() {
    this.$analytics.eventTrack(
      'Completed Registration Step '+ this.step,
      {
        user: this.user,
        product: this.product
      }
    )
  }

  next() {
    this.trackCurrentStep()
    this._clearMessages()
    this._signupStep++
  }

  selectProduct(product) {
    this.product = product
    this.AddOns.get(
      {plan: product},
      this._getAddOnsSuccess.bind(this),
      this._handleAddOnError.bind(this))
    this.next()
    if (product == 'annual') {
      this.subscription = 'Annual Subscription'
    } else if(product == 'monthly') {
      this.subscription = 'Monthly Subscription'
    }
  }

  _getAddOnsSuccess(addOns) {
    this.addOnGetError = ''
    this.addOns = addOns.addOns
  }

  _handleAddOnError() {
    this.addOnGetError = 'We ran into an issue, please try again later.'
  }

  get selectedProduct () {
    return this.product
  }

  get selectedCoverage() {
    return _.keys( _.pick(this.coverage, (val, key) => val === true))
  }

  get priceQuote() {
    return _(this.addOns)
      .filter(a => _.includes(this.selectedCoverage, a.addOn))
      .map(s => s.priceInCents / 100)
      .sum()
  }

  createRegistration() {
    this.submitting = true
    this.signupService.createRegistration(
      this.product, this.user, this.selectedCoverage,
      this._onCreateRegistrationSuccess.bind(this),
      this._onCreateRegistrationFailure.bind(this)
    )
    this.$analytics.eventTrack(
      'Registration Saved',
      {
        user: this.user,
        product: this.product
      }
    )
  }

  submit() {
    this.submitting = true
    this.$log.debug('Submitting to billing')
    this.billingError = ''
    this.billingService.submit(
      $(billingFormSelector),
      this._onBillingSuccess.bind(this),
      this._onBillingError.bind(this)
    )

    this.$analytics.eventTrack('Billing Submitted')
  }

  resend() {
    this.$log.debug('Resending email')
    this.signupService.resend(
      this._registrationId,
      this._onResendSuccess.bind(this),
      this._onResendFailure.bind(this)
    )
  }

  terms() {
    this.submitting = true
    this.termsOfServiceError = ''
    this.http.get(this.termsUrl).then((response) => {
      var modalInstance = this.$uibModal.open({
        animation: true,
        templateUrl: 'terms-of-service-modal.partial.html',
        controller: 'TermsOfServiceModalController',
        size: 'lg'
      })
      modalInstance.result.then(() => {
        this.user.termsOfServiceVersion = response.data.termsOfService.version
        this.submit();
      },
      () => {
        this.submitting = false
        this.termsOfServiceError = 'Before we submit your billing information, you must accept the Terms of Service. Click Submit again if you would like to proceed.'
      })
    }, (response) => {
      this.submitting = false
      this.$log.debug('Terms of service request failed')
      this.termsOfServiceError = 'We could not retrieve the Terms of Service. Please try again later.'
    })
  }

  _clearMessages() {
    this.billingError = ''
    this.resendMessage = ''
    this.resendError = ''
    this.termsOfServiceError = ''
  }

  _onResendSuccess(response) {
    this._clearMessages()
    this.resendMessage = 'Your confirmation email was resent'
  }

  _onResendFailure(response) {
    this._clearMessages()
    this.resendError = 'Your confirmation email could not be resent.'
  }

  _onCreateRegistrationSuccess(response) {
    this.$log.debug('CreateRegistration success', response)
    this._registrationId = response.registration.registrationId

    if ( response.registration.billingInfo ) {
      this._signupStep = 4
      this.resendMessage = 'You previously completed your registration.  We have resent your email with final instructions to activate your account.'
    } else {
      this.billingInfo.first_name = this.user.first
      this.billingInfo.last_name = this.user.last
      this.next()
    }
    this.submitting = false
  }

  _onCreateRegistrationFailure(response) {
    this.$log.debug('CreateRegistration failed', response)
    this.errorMessage = 'Unable to create the registration'
    this.submitting = false
  }

  _onBillingSuccess(token) {
    this.$analytics.eventTrack('Billing Succeeded', { user: this.user })
    this.signupService.registerBillingInfo(
      this._registrationId, token, this.user.email,
      this._onSignupSuccess.bind(this),
      this._onSignupFailure.bind(this)
    )
  }

  _onBillingError(error) {
    this.$analytics.eventTrack('Billing Errored', {error: error})
    this.$log.debug(error)
    this._clearMessages()
    this.billingError = 'There is a problem with your credit card details.  Please double-check the data'
    this.submitting = false
  }

  _onSignupSuccess(response) {
    this.user = {}
    this.product = null
    this.billingInfo = {}

    this.submitting = false
    this.$log.debug(response)
    this.next()
  }

  _onSignupFailure() {
    this.submitting = false
    this.billingError = 'We could not complete your signup at this time. Please try again later.'
  }

}

SignupController.$inject = [
  '$log',
  'AuthService',
  'BillingService',
  'SignupService',
  'AddOns',
  '$uibModal',
  '$http',
  'config',
  '$analytics'
]

export default SignupController
